import { render, staticRenderFns } from "./ediotitem.vue?vue&type=template&id=9b36aab2&scoped=true"
import script from "./ediotitem.vue?vue&type=script&lang=js"
export * from "./ediotitem.vue?vue&type=script&lang=js"
import style0 from "./ediotitem.vue?vue&type=style&index=0&id=9b36aab2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b36aab2",
  null
  
)

export default component.exports